import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { loginRequest, isDevAuthBypass } from '@auth/index';

export function Login() {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const idle = params.get('reason') === 'idle';

  useEffect(() => {
    if (isAuthenticated || isDevAuthBypass()) navigate('/', { replace: true });
  }, [isAuthenticated, navigate]);

  return (
    <div
      className="flex min-h-screen items-center justify-center p-6"
      style={{ background: 'var(--paper)' }}
    >
      <div className="w-full max-w-sm">
        <div className="card" style={{ padding: '32px 28px', textAlign: 'center' }}>
          <div
            className="brand-mark"
            style={{ width: 44, height: 44, fontSize: 26, margin: '0 auto 16px' }}
          >
            LI
          </div>
          <div className="section-eyebrow" style={{ marginBottom: 6 }}>
            ClariDynamics
          </div>
          <h1 className="section-title" style={{ fontSize: '1.9rem', marginBottom: 6 }}>
            Lab <em>Intake</em>
          </h1>
          <p className="mb-7 text-sm" style={{ color: 'var(--ink-600)', lineHeight: 1.55 }}>
            {idle
              ? 'You were signed out after inactivity to protect patient information. Sign in again to continue.'
              : 'Sign in with your ClariDynamics account.'}
          </p>
          <button
            type="button"
            onClick={() => void instance.loginRedirect(loginRequest)}
            className="btn-bench w-full"
          >
            Sign in
          </button>
        </div>
        <div className="editorial-footer" style={{ justifyContent: 'center', marginTop: 14, border: 0 }}>
          Internal · CDX only
        </div>
      </div>
    </div>
  );
}
